export default {
    namespaced: true,

    state: {
        verificationLink: null,
        verificationStatus: null,
        verificationAttempts: null,
    },

    mutations: {
        SET_LINK(state, value) {
            state.verificationLink = value
        },
        SET_STATUS(state, value) {
            state.verificationStatus = value
        },
        SET_ATTEMPTS(state, value) {
            state.verificationAttempts = value
        }
    },

    actions: {
        setLink({ commit }, value) {
            commit('SET_LINK', value)
        },
        setStatus({commit}, value){
            commit('SET_STATUS', value)
        },
        setAttempts({commit}, value){
            commit('SET_ATTEMPTS', value)
        }
    },
}